import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { useAuth } from "../contexts/AuthContext";
import { Shield, User, Building2, Key } from "lucide-react";

export default function SettingsPage() {
  const { user } = useAuth();

  return (
    <div data-testid="settings-page" className="space-y-6 max-w-3xl">
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight" style={{ fontFamily: "Chivo, sans-serif" }}>Settings</h1>

      <Card className="border border-gray-200 shadow-sm rounded-sm">
        <CardContent className="p-5">
          <h3 className="text-sm font-semibold uppercase tracking-[0.15em] text-gray-500 mb-4">Profile</h3>
          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <User size={16} className="text-gray-400" />
              <span className="text-sm text-gray-600 w-24">Name</span>
              <span className="text-sm font-medium">{user?.name}</span>
            </div>
            <div className="flex items-center gap-3">
              <Key size={16} className="text-gray-400" />
              <span className="text-sm text-gray-600 w-24">Email</span>
              <span className="text-sm font-medium">{user?.email}</span>
            </div>
            <div className="flex items-center gap-3">
              <Shield size={16} className="text-gray-400" />
              <span className="text-sm text-gray-600 w-24">Roles</span>
              <div className="flex gap-1">{user?.roles?.map((r) => <Badge key={r} variant="secondary" className="rounded-sm text-[10px]">{r}</Badge>)}</div>
            </div>
            <div className="flex items-center gap-3">
              <Building2 size={16} className="text-gray-400" />
              <span className="text-sm text-gray-600 w-24">Companies</span>
              <span className="text-sm">{user?.companies?.map((c) => c.name).join(", ") || "—"}</span>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="border border-gray-200 shadow-sm rounded-sm">
        <CardContent className="p-5">
          <h3 className="text-sm font-semibold uppercase tracking-[0.15em] text-gray-500 mb-4">System Information</h3>
          <div className="space-y-2 text-sm text-gray-600">
            <div>Version: Archon v1.0.0</div>
            <div>Environment: UAT</div>
            <div>SAP Integration: <Badge variant="outline" className="ml-1 rounded-sm text-[10px]">MOCKED</Badge></div>
            <div>Queue: <Badge variant="outline" className="ml-1 rounded-sm text-[10px]">In-Memory</Badge></div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
